<template>
  <div>
    <el-dialog
      ref="breakageDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h550_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('breakageDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="loadingText"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogBreakageForm"
          :model="dialogBreakageForm"
          :rules="dialogBreakageFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="18">
                  <el-form-item label="资产名称">
                    <el-input
                      v-model="dialogViewForm.name"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="计量单位">
                    <el-input
                      v-model="dialogViewForm.unit"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item label="管理人员">
                    <el-input
                      v-model="dialogViewForm.managerName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="管理数量">
                    <el-input
                      v-model="dialogViewForm.manageNumber"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="借出数量">
                    <el-input
                      v-model="dialogViewForm.lentNumber"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="损坏遗失数量">
                    <el-input
                      v-model="dialogViewForm.damageNumber"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>

          <div class="modal-box">
            <h3 class="modal-title">
              报废|遗失信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item
                    label="类型"
                    required
                  >
                    <el-radio-group v-model="dialogBreakageForm.damageType">
                      <el-radio :label="8">
                        遗失
                      </el-radio>
                      <el-radio :label="9">
                        报废
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="报废|遗失数量"
                    prop="damageNumber"
                  >
                    <el-input v-model="dialogBreakageForm.damageNumber" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item
                    label="报废|遗失说明"
                    prop="damageRemark"
                  >
                    <el-input
                      v-model="dialogBreakageForm.damageRemark"
                      type="textarea"
                      placeholder="请输入报废|遗失说明"
                      show-word-limit
                      maxlength="128"
                      rows="3"
                      style="margin-top: -8px;"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          :disabled="operateButtonDisable"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 数据请求
import { breakageFixedAssetApi, initFixedAssetApi } from '@/api/fixedAsset'

export default {
  components: {},
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: null
    }
  },
  data() {
    // 损坏遗失数量
    const validateDamageNumber = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入要报废或遗失的数量'))
      } else if (Number(value) === 0) {
        callback(new Error('固定资产报废或遗失的数量不能为0'))
      } else if (!/^(0|([1-9][0-9]*))(\.[\d]{1,2})?$/.test(value)) {
        callback(new Error('请输入正确格式的内容，允许输入数据格式为：大于0的数字(小数点后最多2位)'))
      } else if (Number(value) > (Number(this.dialogViewForm.manageNumber) - Number(this.dialogViewForm.lentNumber))) {
        callback(new Error('固定资产报废或遗失的数量不能超过管理数量 - 借出数量'))
      } else {
        callback()
      }
    }
    return {
      operateButtonDisable: false,
      loading: false,
      loadingText: '努力加载数据中，请耐心等待',

      dialogViewForm: {},
      dialogBreakageForm: {},
      dialogBreakageFormRules: {
        damageNumber: [{ required: true, validator: validateDamageNumber, trigger: 'blur' }],
        damageRemark: [{ max: 128, message: '报废|遗失说明最多输入 128 个字符', trigger: 'blur' }]
      },
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        let _this = this
        _this.loading = true
        _this.loadingText = '努力加载数据中，请耐心等待'
        _this.operateButtonDisable = false

        _this.dialogViewForm = {}
        _this.dialogBreakageForm = {
          id: _this.dataId,
          damageType: 8,
          damageNumber: 0,
          damageRemark: ''
        }
        _this.initFixedAssetData()

        _this.$nextTick(() => {
          _this.$refs.dialogBreakageForm.clearValidate()
          _this.loading = false
        })
      }
    }
  },
  methods: {
    // 初始化固定资产数据
    initFixedAssetData() {
      let _this = this
      initFixedAssetApi({ id: _this.dataId }).then(response => {
        const { data } = response
        _this.dialogViewForm = data || {}
      })
    },
    // 加载数据
    reloadData() {
      this.$emit('reloadData')
    },
    modalClose() {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogBreakageForm.clearValidate()
    },
    // 新增|修改保存
    handleSave() {
      let _this = this
      _this.$refs.dialogBreakageForm.validate(valid => {
        if (valid) {
          this.$confirm('是否确定保存', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
            _this.operateButtonDisable = true
            _this.loading = true
            _this.loadingText = '正在处理数据中，请耐心等待'

            breakageFixedAssetApi(_this.dialogBreakageForm).then(res => {
              _this.$message({ message: res.message, type: 'success' })
              _this.reloadData()
              _this.modalClose()
            }).catch(() => {
              _this.loading = false
              _this.operateButtonDisable = false
            })
          }).catch(() => { })
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.el-table--border {
  border-left: 1px solid #dfe6ec;
  margin-top: 5px;
}
::v-deep .el-table {
  th {
    color: #ffffff;
    .cell {
      line-height: 17px;
    }
    .caret-wrapper {
      height: 18px;
    }
    .sort-caret {
      border-width: 4px;
      &.ascending {
        top: 0;
      }
      &.descending {
        bottom: 0;
      }
    }
  }
  .ascending .sort-caret.ascending {
    border-bottom-color: #ffffff;
  }
  .descending .sort-caret.descending {
    border-top-color: #ffffff !important;
  }
}
::v-deep .el-table--mini th,
::v-deep .el-table--mini td {
  padding: 4px;
  font-size: 12px;
  .cell {
    line-height: 16px;
  }
}

::v-deep .el-table__row {
  .el-form-item__error {
    display: none;
  }
  .el-form-item--mini.el-form-item {
    margin-bottom: 0px;
  }
}

.source-textarea {
  ::v-deep .el-textarea__inner {
    margin-top: 0px;
    font-size: 12px;
  }
}
</style>
